// User Action Types
export const SET_USER = 'SET_USER';
export const CLEAR_USER = "CLEAR_USER";

// Channel Action Type
export const SET_CURRENT_CAHNNEL = "SET_CURRENT_CAHNNEL";
export const SET_PRIVATE_CHANNEL = "SET_PRIVATE_CHANNEL";
export const SET_USER_POSTS = "SET_USER_POSTS";

// color action types
export const SET_COLORS = "SET_COLORS";

// emotion detect
export const SET_EMOTION = "SET_EMOTION";





// WEBPACK FOOTER //
// ./src/actions/types.js